<footer class="container-fluid text-center">
    <p>&copy; 2023 {{appName}} &nbsp; {{appVersion}} | <a href="#" target="_blank">NXG Labs</a></p>
</footer>
